import React from 'react';
import { Modal } from 'react-bootstrap';
import './kite_sync_check.component.css';

const KiteSyncCheck = (props) => {
  const { show, setShow, onConfirm, pf } = props;
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered={true}
      className="kite_sync_check"
    >
      <Modal.Body>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="vuesax/linear/refresh-2">
            <g id="refresh-2">
              <path
                id="Vector"
                d="M14.6668 7.99998C14.6668 11.68 11.6802 14.6666 8.00016 14.6666C4.32016 14.6666 2.0735 10.96 2.0735 10.96M2.0735 10.96H5.08683M2.0735 10.96V14.2933M1.3335 7.99998C1.3335 4.31998 4.2935 1.33331 8.00016 1.33331C12.4468 1.33331 14.6668 5.03998 14.6668 5.03998M14.6668 5.03998V1.70665M14.6668 5.03998H11.7068"
                stroke="#878787"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </g>
        </svg>
        <h6>Sync Portfolio</h6>
        <p>
          You are trying to sync another portfolio <b>{pf && pf.name}</b>. Would
          like to proceed with same, please click yes to continue
        </p>
        <div className="btns_cont">
          <button
            type="button"
            className="cancel_btn"
            onClick={() => setShow(false)}
          >
            Cancel
          </button>
          <button type="button" className="confirm_btn" onClick={onConfirm}>
            Yes, Continue
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default KiteSyncCheck;
